import React from 'react';
import { createRoot } from 'react-dom/client';

import { Router } from './Router';

const container = document.querySelector('.app');
const root = createRoot(container as Element);

root.render(<Router />);
